export default {
  title: 'Disable access to a platform',
  subtitle: 'You can disable a user\'s access to a platform',
  searchLabel: 'Search',
  disableAccess: 'Disable access to',
  qDialog: {
    title: 'Confirmation required',
    subtitle: 'Disabling access to this platform',
    content: 'Are you sure you want to disable access to {platformDisable} for '
  },
  noUser: 'No user found',
  listOfUsersTable: {
    name: 'First name, Last name',
    email: 'Email address',
    type: 'Type',
    access: 'Access'
  }
}
